<h3 class="ui header light user-step-title">

  Course Outcomes</h3>

<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.message"></app-loading>
</div>

<ng-template #loaded>



  <div class="user-step-instruction">
    List course outcomes for this course.
  </div>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>

  <ng-template #noErrors>

    <!-- <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
    </app-action-errors> -->


    <div *ngIf="courseOutcomes.length == 0; else courseOutcomesExist" class="ui message">
      There are no course outcomes.
    </div>

    <ng-template #courseOutcomesExist>

      <table class="ui table celled course-outcome-table" *ngIf="courseOutcomes && courseOutcomes.length > 0">

        <ng-container *ngFor="let courseOutcome of courseOutcomes; let i = index;">

          <tr class="course-outcome" id="outcome-{{courseOutcome.id}}">
            <td class="course-outcome-index">
              {{i+1}}
            </td>
            <td>
              <div class="course-outcome-title">{{courseOutcome.description}}</div>
            </td>

            <td class="button-col">
              <button class="ui button basic mini" (click)="editCourseOutcomeForm(courseOutcome)">Edit</button>
              <button class="ui button basic mini delete-button" (click)="deleteCourseOutcome(courseOutcome)">Delete</button>
            </td>

          </tr>

        </ng-container>

      </table>

    </ng-template>

    <div class="button-area">

      <div class="add-button-area">
        <button class="ui primary button action save-button tiny" (click)="openAddCourseOutcomeForm()">
          <i class="icon plus"></i>Add Course Outcome</button>
      </div>

      <!-- <div class="nav-button-area">

        <button *ngIf="currentStepIndex != 0" class="ui left labeled icon button prev-step-button tiny" (click)="previousStepClicked()">
          <i class="left arrow icon"></i>Previous - {{ userSteps[currentStepIndex-1].title }}</button>
        <button *ngIf="currentStepIndex != userSteps.length -1" class="ui right labeled icon  button next-step-button tiny"
          (click)="nextStepClicked()">
          <i class="right arrow icon"></i>Next - {{ userSteps[currentStepIndex+1].title }}</button>
      </div> -->



    </div>

  </ng-template>

</ng-template>


<div class="modal-window" *ngIf="courseOutcomeForForm" [ngClass]="{'show': shouldShowForm, 'hide': !shouldShowForm}">

  <div id="course-outcome-form-modal">
    <div class="modal-window-header">
      Course Outcome</div>

    <div class="modal-window-content ui form">

      <div class="form-area">

        <div class="required field">

          <label>Course outcome description</label>

          <div class="field-instruction">
            Please submit each course outcome separately.
          </div>

          <textarea rows="2" placeholder="Please describe the course outcome." [(ngModel)]="courseOutcomeForForm.description"></textarea>
          <div class="ui pointing red left basic label" *ngIf="!isDescriptionFilled">
            Course outcome is required.
          </div>

        </div>

      </div>

    </div>

    <div class="modal-actions">
      <span class="updatingForm" *ngIf="formProcessing">Processing..</span>
      <button class="ui basic button tiny deny" (click)="cancelForm()" [disabled]="formProcessing || formDataLoading">Cancel</button>
      <button class="ui primary button tiny approve" (click)="submitForm()" [disabled]="formProcessing ||  formDataLoading"
        [ngClass]="{'loading': formProcessing}">Save</button>
    </div>

  </div>

</div>

<!-- Delete dialog -->
<app-dialog [dialog]="dialog" [updating]="dialogUpdating" (closeDialog)="closeDialog()" (submitDialog)="proceedDelete()">
</app-dialog>
<!-- End Delete Dialog -->
